module.exports = __webpack_public_path__ + "img/contato.aa4ef242.svg";